import { LOCATION_CHANGE } from 'react-router-redux';

function animation(state = {}, action) {
  switch (action.type) {
    case 'SENDING_ANSWERS' :
      return { ...state, question: 'fadeOutLeft animated', sendingLoading: 'fadeIn animated-d1s' };
    case 'SENT_ANSWERS' :
      return { ...state, question: 'fadeInRight animated-d1s', sendingLoading: 'fadeOut animated' };
    case 'DATA_RECEIVED' :
      return { ...state, question: '' };
    case 'GO_BACK' :
      return { ...state, question: 'fadeOutRight animated' };
    case 'SENDING_ANSWERS_LAST_PAGE':
      return {  };
    case'SENT_ANSWERS_LAST_PAGE' :
      return {  };
    case LOCATION_CHANGE :
      if (action.payload.action === 'POP') {
        if (state.question === 'fadeOutRight animated') {
          return { ...state, question: 'fadeInLeft animated' };
        }
        return { ...state, question: 'fadeIn animated' };
      }
      return state;

    case 'FADE_OUT_STATUS_MODAL' :
      return { ...state, modal: 'fadeOut animated' };
    case 'SHOW_STATUS_MODAL' :
      return { ...state, modal: 'fadeIn animated' };
    default:
      return state;
  }
}

export default animation;
